import clsx from 'clsx';
import React from 'react';

var TUXNavBarTextAction = function TUXNavBarTextAction(_ref) {
  var text = _ref.text,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
      disabled = _ref.disabled,
      onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("button", {
    className: clsx('tux-nav-bar-text-action h-40 px-8', disabled && 'text-color-TextQuaternary', {
      'primary': 'H4-SemiBold' + (!disabled ? " text-color-Primary" : ""),
      'secondary': 'H4-Regular' + (!disabled ? " text-color-TextPrimary" : "")
    }[variant]),
    disabled: disabled,
    onClick: onClick
  }, text);
};

export { TUXNavBarTextAction };
//# sourceMappingURL=TUXNavBarTextAction.js.map
